import { API, graphqlOperation } from 'aws-amplify';

const addSurveyMutation = `
  mutation($companyId: String!, $adminId: String!) {
    addSurvey(
      companyId: $companyId,
      adminId: $adminId,
    ) {
      id
    }
  }
`;

const addSurveyQuestionMutation = `
  mutation($companyId: String!, $surveyId: String!, $body: String!) {
    addSurveyQuestion(
      companyId: $companyId,
      surveyId: $surveyId,
      body: $body
    ) {
      id
    }
  }
`;

const answerSurveyQuestionMutation = `
  mutation(
    $userId: String!,
    $userAccountType: String!,
    $surveyQuestionId: String!, 
    $surveyId: String!,
    $body: String!
   ) {
    answerSurveyQuestion(
      userId: $userId,
      userAccountType: $userAccountType,
      surveyQuestionId: $surveyQuestionId,
      surveyId: $surveyId,
      body: $body
    ) {
      id
    }
  }
`;

const getActiveSurveyQuery = `
  query($companyId: String!) {
    getActiveSurvey(
      companyId: $companyId
    ) {
      id
      surveyId
      body
    }
  }
`;

const getSurveyResponsesQuery = `
  query(
    $userId: String,
    $surveyId: String!,
  ) {
    getSurveyResponses(
      userId: $userId,
      surveyId: $surveyId
    ) {
      id
      body
    }
  }
`;

const getYesNoSurveyResultsQuery = `
  query(
    $companyId: String!,
  ) {
    getYesNoSurveyResults(
      companyId: $companyId
    ) {
      yesPercentage
      yesCount
      noPercentage
      noCount
    }
  }
`;

export function addSurveyQuestion({ COMPANY_ID, SURVEY_ID, BODY }) {
  return API.graphql(
    graphqlOperation(addSurveyQuestionMutation, {
      companyId: COMPANY_ID,
      surveyId: SURVEY_ID,
      body: BODY,
    })
  );
}

export function addSurvey({ COMPANY_ID, ADMIN_ID }) {
  return API.graphql(
    graphqlOperation(addSurveyMutation, {
      companyId: COMPANY_ID,
      adminId: ADMIN_ID,
    })
  );
}

export function answerSurveyQuestion({
  USER_ID,
  USER_ACCOUNT_TYPE,
  SURVEY_QUESTION_ID,
  SURVEY_ID,
  BODY,
}) {
  return API.graphql(
    graphqlOperation(answerSurveyQuestionMutation, {
      userId: USER_ID,
      userAccountType: USER_ACCOUNT_TYPE,
      surveyQuestionId: SURVEY_QUESTION_ID,
      surveyId: SURVEY_ID,
      body: BODY,
    })
  );
}

export function getActiveSurvey({ COMPANY_ID }) {
  return API.graphql(
    graphqlOperation(getActiveSurveyQuery, {
      companyId: COMPANY_ID,
    })
  );
}

export function getSurveyResponses({ USER_ID, SURVEY_ID }) {
  return API.graphql(
    graphqlOperation(getSurveyResponsesQuery, {
      userId: USER_ID,
      surveyId: SURVEY_ID,
    })
  );
}

export function getYesNoSurveyResults({ COMPANY_ID }) {
  return API.graphql(
    graphqlOperation(getYesNoSurveyResultsQuery, {
      companyId: COMPANY_ID,
    })
  );
}
